function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { PureComponent } from "react";
import TabsComponent from "/components/core/tabs/tabs-component";
import TabComponent from "/components/core/tabs/tab/tab-component";
import TwoThirdsTextAndAssetComponent from "segments/desktop/text-and-asset/layouts/two-thirds-text-and-asset/two-thirds-text-and-asset-component";
import Colors from "styles/colors";
import { StyledRegularTabsComponent } from "./regular-tabs-component.scss";
import DefaultProps from "./deafult-props";
const MINIMUN_NUM_OF_TABS_FOR_SMALL_LABELS = 5;
class RegularTabsComponent extends PureComponent {
    tabsRenderer() {
        const { theme, tabs, tabsColor, tabsBackgroundColor } = this.props;
        const useSmallLabels = tabs.length >= MINIMUN_NUM_OF_TABS_FOR_SMALL_LABELS;
        return tabs.map((tab, index)=>{
            const { tabLabel, textAndAsset, tabId } = tab;
            return /*#__PURE__*/ _jsx(TabComponent, {
                theme: theme,
                tabId: tabId,
                label: tabLabel,
                color: tabsColor,
                backgroundColor: tabsBackgroundColor,
                useSmallLabels: useSmallLabels,
                children: /*#__PURE__*/ _createElement(TwoThirdsTextAndAssetComponent, _object_spread_props(_object_spread({}, textAndAsset), {
                    key: index
                }))
            }, index);
        });
    }
    renderTwoThirdsComponents() {
        const { tabs, tabsColor } = this.props;
        return tabs.map((tab, index)=>{
            const { tabLabel, textAndAsset } = tab;
            return /*#__PURE__*/ _jsxs("div", {
                className: "two-third-text-and-asset-component-wrapper",
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        className: "tab-label-container",
                        style: {
                            color: Colors[tabsColor]
                        },
                        children: /*#__PURE__*/ _jsxs("div", {
                            className: "tab-label",
                            children: [
                                tabLabel,
                                /*#__PURE__*/ _jsx("div", {
                                    className: "tab-label-underline",
                                    style: {
                                        backgroundColor: Colors[tabsColor]
                                    }
                                })
                            ]
                        })
                    }),
                    /*#__PURE__*/ _jsx(TwoThirdsTextAndAssetComponent, _object_spread({}, textAndAsset))
                ]
            }, index);
        });
    }
    renderLargeScreenComponent() {
        const { autoTransition, scrollOnTabClick, scrollSpeed, distanceFromTop, activeTabId } = this.props;
        return /*#__PURE__*/ _jsx("div", {
            className: "large-screen-component-wrapper",
            children: /*#__PURE__*/ _jsx(TabsComponent, {
                autoTransition: autoTransition,
                scrollOnTabClick: scrollOnTabClick,
                scrollSpeed: scrollSpeed,
                distanceFromTop: distanceFromTop,
                activeTabId: activeTabId,
                role: "tabpanel",
                children: this.tabsRenderer()
            })
        });
    }
    renderSmallScreenComponent() {
        return /*#__PURE__*/ _jsx("div", {
            className: "small-screen-component-wrapper",
            children: this.renderTwoThirdsComponents()
        });
    }
    render() {
        return /*#__PURE__*/ _jsxs(StyledRegularTabsComponent, {
            className: "regular-tabs-component",
            children: [
                this.renderLargeScreenComponent(),
                this.renderSmallScreenComponent()
            ]
        });
    }
}
export { RegularTabsComponent as default };
RegularTabsComponent.defaultProps = DefaultProps;
